import { env } from "../config/env";

type SocialShareProps = {
  title: string;
  path?: string;
  label?: string;
};

type SocialLinksProps = {
  facebookUrl?: string;
  youtubeUrl?: string;
};

function absoluteUrl(path?: string) {
  const siteUrl = env.siteUrl.replace(/\/$/, "");
  const currentPath = path || window.location.pathname;
  return `${siteUrl}${currentPath.startsWith("/") ? currentPath : `/${currentPath}`}`;
}

export function facebookShareUrl(path?: string) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(absoluteUrl(path))}`;
}

export function SocialLinks({ facebookUrl = env.facebookUrl, youtubeUrl = "" }: SocialLinksProps) {
  const links = [
    facebookUrl ? { label: "Facebook", href: facebookUrl } : null,
    youtubeUrl ? { label: "YouTube", href: youtubeUrl } : null,
  ].filter((link): link is { label: string; href: string } => Boolean(link));

  if (!links.length) return null;
  return (
    <div className="social-links" aria-label="Social media links">
      {links.map((link) => (
        <a key={link.label} href={link.href} target="_blank" rel="noreferrer">{link.label}</a>
      ))}
    </div>
  );
}

export function SocialShare({ title, path, label = "Share" }: SocialShareProps) {
  const url = absoluteUrl(path);
  const shareText = `${title} - ${env.schoolName}`;

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(url);
      alert("Link copied.");
    } catch {
      window.prompt("Copy this link:", url);
    }
  }

  return (
    <div className="share-actions" aria-label={`Share ${title}`}>
      <span>{label}</span>
      <a href={facebookShareUrl(path)} target="_blank" rel="noreferrer">Facebook</a>
      <a href={`mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(url)}`}>Email</a>
      <button type="button" className="text-button" onClick={copyLink}>Copy Link</button>
    </div>
  );
}
